'use client';

import { useAnalyticsConsentSync } from './hooks/useAnalyticsConsentSync';
import { useAnalyticsGroupSync } from './hooks/useAnalyticsGroupSync';
import { useAnalyticsIdentity } from './hooks/useAnalyticsIdentity';
import { useGclidTracking } from './hooks/useGclidTracking';
import { usePageTracking } from './hooks/usePageTracking';

interface AnalyticsRuntimeProps {
  group?: {
    id: string;
    site_name: string;
    tenant_id: string;
  };
}

export function AnalyticsRuntime({ group }: AnalyticsRuntimeProps) {
  useAnalyticsConsentSync();
  useAnalyticsGroupSync(group);
  useAnalyticsIdentity();
  useGclidTracking();
  usePageTracking();

  return null;
}
